import React from "react";

export const CardType1 = ({ events }) => {
  return (
    <div>
      <div className="card event-card mt-6">
        <div className="card-image">
          <figure className="image is-4by3">
            <img src={events?.image} alt={events?.title} />
          </figure>
        </div>
        <div className="card-content is-flex">
          <div className="events-date has-background-custom-red has-text-white has-text-centered mr-4 date-container is-flex is-flex-direction-column is-align-items-center is-justify-content-center">
            <p className="is-size-4 has-text-weight-bold">{events?.date}</p>
            <p>{events?.month}</p>
          </div>
          <div>
            <p className="title sub-title is-6">{events?.title}</p>
            <p className="is-size-7">
              <span className="icon-text">
                <span className="icon">
                  <i className="fas fa-calendar-alt"></i>
                </span>
                <span>
                  {" "}
                  <img src={events?.calenderIcon} /> {events?.time}
                </span>
              </span>
            </p>
            <p className="is-size-7 mt-1">
              <span className="icon-text">
                <span className="icon">
                  <i className="fas fa-map-marker-alt"></i>
                </span>
                <span>
                  {" "}
                  <img src={events?.locationIcon} /> {events?.location}
                </span>
              </span>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};
